module.exports = __webpack_public_path__ + "static/google-play-badge-ms-130c59fdadc76b5240cc929aad83ef42.png";